import API from '@/lib/API.js'
import comun from './comun.js'
const situacionrevista = {
    namespaced: true,
    state: {
        Lista: [],
        Seleccionado: undefined
    },
    mutations: {
        init(state) {
            state.Seleccionado = undefined;
        },
        set(state, payload) {
            state.Lista = payload;
        },
        select(state, payload) {
            state.Seleccionado = payload;
        },
    },
    actions: {
        async set({
            commit,
            getters
        }) {
            let entidades = getters.get();
            if (entidades.length === 0) {
                commit("comun/cargando")
                let data = await API.Situacion_Revista.traerTodos();
                commit("set", data)
                commit("comun/fincarga")
            }
        },
        select({
            commit
        }, payload) {
            commit("select", payload)
        },
        selectPorId({
            commit,
            state
        }, payload) {
            commit("comun/cargando")
            let sec = state.Lista.find((x) => x.id_sr == payload)
            commit("select", sec)
            commit("comun/fincarga")
        },
        setNuevo({
            commit
        }) {
            commit("comun/cargando")
            let sec = {
                id_sr: 0,
                descripcion_sr: ""
            }
            commit("select", sec)
            commit("comun/fincarga")
        },
        async guardar({
            commit,
            dispatch,
            state
        }) {
            //commit("comun/cargando")
            let data = []
            let str = ""
            if (state.Seleccionado.id_sr != 0) {
                data = await API.Situacion_Revista.modificar(state.Seleccionado);
                str += "Situacion de revista modificada"
            } else {
                data = await API.Situacion_Revista.alta(state.Seleccionado);
                str += `nueva Situacion de revista de alta' ${data.descripcion_sr}'`
            }
            let secs = await API.Situacion_Revista.traerTodos();
            commit("set", secs)
            //commit("select", data)
            dispatch("selectPorId", data.id_sr)
            //commit("comun/fincarga")
            commit("comun/mostrar", str)
        },
        async guardarEntidad({
            commit,
            dispatch
        }, entidad) {
            //commit("comun/cargando")
            let data = []
            let str = ""
            if (entidad.id_sr != 0) {
                data = await API.Situacion_Revista.modificar(entidad);
                str += "Situacion de revista modificada"
            } else {
                data = await API.Situacion_Revista.alta(entidad);
                str += `nueva Situacion de revista de alta' ${data.descripcion_sr}'`
            }
            let ents = await API.Situacion_Revista.traerTodos();
            commit("set", ents)
            //commit("select", data)
            dispatch("selectPorId", data.id_sr)
            //commit("comun/fincarga")
            commit("comun/mostrar", str)
        },
        async eliminar({
            commit
        }, id) {
            let str = ""
            if (id != 0) {
                await API.Situacion_Revista.eliminar(id);
                str += "Situacion de revista eliminada"
            }
            let ents = await API.Situacion_Revista.traerTodos();
            commit("set", ents)
            commit("comun/mostrar", str)
        },
    },
    getters: {
        get: state => () => {
            return state.Lista;
        },
    },
    modules: {
        comun,
    }

}
export default situacionrevista;